import { intlFormatPropTypes } from "react-intl";
import { z } from "zod";

import { MAX_DATE_RATE_DAYS } from "./DateRateForm.consts";

/**
 * Validation for a new date based rate: one or more days (up to
 * MAX_DATE_RATE_DAYS) and a positive hourly rate.
 */
const dateRateSchema = (intl: intlFormatPropTypes) => {
  const dateRequiredMessage = intl.formatMessage({
    id: "hosting.date_rate_form.date_required",
    defaultMessage: "Please select a date or date range",
  });

  return z.object({
    dates: z
      .array(z.date(), { required_error: dateRequiredMessage })
      .min(1, dateRequiredMessage)
      .max(
        MAX_DATE_RATE_DAYS,
        intl.formatMessage(
          {
            id: "hosting.date_rate_form.date_range_too_long",
            defaultMessage: "Please select {maxDays} days or fewer",
          },
          { maxDays: MAX_DATE_RATE_DAYS },
        ),
      ),
    hourlyRate: z
      .string()
      .trim()
      .refine(
        (hourlyRate) => Number(hourlyRate) > 0,
        intl.formatMessage({
          id: "hosting.date_rate_form.hourly_rate_required",
          defaultMessage: "Please enter an hourly rate greater than 0",
        }),
      ),
  });
};

type DateRateFormValues = z.infer<ReturnType<typeof dateRateSchema>>;

export { type DateRateFormValues, dateRateSchema };
